(function () {
  'use strict';

  function getProductJson() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Failed to parse product JSON:', e);
      return null;
    }
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var noDecimals = format.indexOf('amount_no_decimals') !== -1;
    var value = noDecimals
      ? Math.round(cents / 100).toString()
      : (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, value);
  }

  function init() {
    var product = getProductJson();
    var optionsWrap = document.querySelector('.product-options');
    var hiddenInput = document.getElementById('ProductVariantId');
    if (!product || !hiddenInput) return;

    var priceEl = document.getElementById('ProductPrice');
    var comparePriceEl = document.getElementById('ProductComparePrice');
    var saveBadgeEl = document.getElementById('ProductSaveBadge');
    var addBtn = document.getElementById('ProductAddToCart');
    var selected = {};

    var current = product.variants.find(function (v) {
      return v.id === parseInt(hiddenInput.value, 10);
    });
    if (current) {
      selected[0] = current.option1;
      selected[1] = current.option2;
      selected[2] = current.option3;
    }

    function findVariant() {
      return product.variants.find(function (v) {
        return (selected[0] === undefined || v.option1 === selected[0]) &&
               (selected[1] === undefined || v.option2 === selected[1]) &&
               (selected[2] === undefined || v.option3 === selected[2]);
      });
    }

    function updateSwatchUI() {
      if (!optionsWrap) return;
      optionsWrap.querySelectorAll('.swatch-btn').forEach(function (btn) {
        var idx = btn.dataset.optionIndex;
        btn.classList.toggle('is-selected', selected[idx] === btn.dataset.value);
      });
    }

    function applyVariant(variant) {
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        return;
      }

      hiddenInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.className = variant.compare_at_price > variant.price ? 'price-sale' : 'price-regular';
      }

      if (comparePriceEl && saveBadgeEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
          var discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saveBadgeEl.textContent = 'Save ' + discount + '%';
          saveBadgeEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
          saveBadgeEl.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    if (optionsWrap) {
      optionsWrap.querySelectorAll('.swatch-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[this.dataset.optionIndex] = this.dataset.value;
          updateSwatchUI();
          applyVariant(findVariant());
        });
      });
    }

    updateSwatchUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
